import { IAuthorityHistoryChange } from './authority-history-change.interace';

export class AuthorityHistoryChangeModel {
  changeText: string;
  changeType: string;
  constructor(authorityHistoryChange: IAuthorityHistoryChange) {
    this.changeText = authorityHistoryChange.changeText ? authorityHistoryChange.changeText : '';
    this.changeType = authorityHistoryChange.changeType ? authorityHistoryChange.changeType : '';
  }
}
